import { render } from "./SectionBullets.vue?vue&type=template&id=24543d80"
import script from "./SectionBullets.vue?vue&type=script&lang=js"
export * from "./SectionBullets.vue?vue&type=script&lang=js"

import "./SectionBullets.vue?vue&type=style&index=0&id=24543d80&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__